// get viewport height
let vh = window.innerHeight * 0.01;

// set --vh
// for root element
document.documentElement.style.setProperty("--vh", vh + "px");

window.addEventListener("resize", function () {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");
});

// get viewport height
const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
$(window).on("load, resize", appHeight);
appHeight();
